// Vendors
import { getTrackingInstance } from '@openbank/cf-ui-framework';
// Constants
import { TRACKING_CONFIGURATION } from './constants/app-tracking.constants';

const useAppTrackingHook = <T>(TrackingHandlers: (track) => T): T => {
  const { track } = getTrackingInstance({ ...TRACKING_CONFIGURATION } as any).trackEvent();

  return TrackingHandlers(track);
};

export { useAppTrackingHook };
